<template>
  <v-app style="margin: 0px; padding: 0px; width: 100%; height: 100%">
    <v-main>
      <v-container
        fluid
        fill-height
        :class="$vuetify.breakpoint.xs ? 'pa-0 ma-0' : ''"
      >
        <v-card
          id="login-card"
          :loading="this.isLoading"
          :class="$vuetify.breakpoint.xs ? 'ma-0 pa-5' : 'mt-10'"
          outlined
          elevation="2"
          :width="$vuetify.breakpoint.xs ? '100%' : '450px'"
          :style="
            $vuetify.breakpoint.xs
              ? 'padding: 0; margin: 0;'
              : 'padding: auto; margin: auto;'
          "
        >
          <template slot="progress">
            <v-progress-linear
              color="accent"
              indeterminate
              height="5px"
            ></v-progress-linear>
          </template>
          <v-form
            id="form"
            ref="form"
            class="signup-form text-center px-5 pt-2"
            method="POST"
            :action="loginRoute"
            lazy-validation
            @submit.prevent="submit"
          >
            <input type="hidden" name="_token" :value="csrf" />
            <v-card-title class="justify-center pt-5"
              >Sign In to Uni-Truths</v-card-title
            >

            <v-text-field
              id="email"
              v-model="email"
              type="email"
              name="email"
              label="Email"
              :rules="emailRules"
              outlined
              hide-details="auto"
              validate-on-blur
            ></v-text-field>

            <v-text-field
              id="password"
              v-model="password"
              :append-icon="passwordVisible ? 'mdi-eye' : 'mdi-eye-off'"
              :type="passwordVisible ? 'text' : 'password'"
              name="password"
              label="Password"
              :rules="passwordRules"
              @click:append="passwordVisible = !passwordVisible"
              outlined
              hide-details="auto"
              validate-on-blur
            ></v-text-field>

            <v-card-text class="text-right" style="padding: 0 20px 8px 0"
              ><a :href="forgottenPasswordRoute">
                Forgot your password?</a
              ></v-card-text
            >

            <div class="row-wrapper-smaller flex-column">
              <span
                v-for="e in this.getErrors(errors)"
                :key="e"
                class="error-text"
              >
                {{ e }} <br
              /></span>
            </div>

            <input type="hidden" name="fb_user_id" :value="fb_user_id" />
            <input
              type="hidden"
              name="fb_user_access_token"
              :value="fb_user_access_token"
            />

            <v-btn
              :disabled="this.isLoading"
              color="primary"
              id="register"
              type="submit"
              x-large
              depressed
              >Login</v-btn
            >
            <v-card-text class="checkbox-text pb-0"
              >Not signed up?
              <a :href="registrationRoute">Create an account</a>
            </v-card-text>
          </v-form>

          <hr class="hr-text" data-content="OR" />

          <continue-with-facebook
            :csrf="csrf"
            :facebook-registration-route="facebookRegistrationRoute"
            :white-facebook-logo="whiteFacebookLogo"
          />
        </v-card>
      </v-container>
    </v-main>
  </v-app>
</template>
<script>
import ContinueWithFacebook from "./../shared/buttons/ContinueWithFacebook";

export default {
  components: {
    ContinueWithFacebook,
  },
  data() {
    return {
      email: "",
      emailRules: [
        (v) => !!v || "You must enter an email address",
        (v) => /.+@.+\.[^\s]/.test(v) || "E-mail must be valid",
      ],
      password: "",
      passwordRules: [
        (v) => !!v || "You must enter a password",
        (v) => v.length >= 8 || "Minimum 8 characters",
      ],
      isLoading: false,
      passwordVisible: false,
    };
  },
  props: {
    csrf: String,
    errors: String,
    fb_user_id: String,
    fb_user_access_token: String,
    "registration-route": String,
    "login-route": String,
    "tos-route": String,
    "privacy-route": String,
    "facebook-registration-route": String,
    "white-facebook-logo": String,
    "forgotten-password-route": String,
  },

  methods: {
    getErrors(e) {
      return [].concat.apply([], Object.values(JSON.parse(e)));
    },
    submit() {
      if (this.$refs.form.validate()) {
        this.isLoading = true;
        document.getElementById("form").submit();
      }
    },
  },
};
</script>
<style scoped>
/*  content padding/margins need to be removed
    for mobile styling not to have a border
*/
html,
body {
  height: 100%;
}

#content {
  padding: 0;
  margin: 0;
}

.error-text {
  color: rgb(235, 28, 28);
}

#icon-fb {
  width: 2rem;
  margin-right: 8px;
  margin-bottom: 2px;
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
}

/*Vuetify*/

.v-input {
  width: 90%;
  margin-left: 5% !important;
  margin-bottom: 10px !important;
}

.v-label {
  font-size: 90%;
  margin-bottom: 0 !important;
}

.v-btn {
  width: 90%;
}

.v-form {
  word-break: break-word !important
}

@media (orientation: portrait) {
  #login-card {
    border: none !important;
    box-shadow: none !important;
    padding: 0 !important;
  }
  .container.fill-height {
    align-items: flex-start;
  }
  .container {
    background-color: white;
  }
}
</style>
